import { membersBaseURL } from "@/functions/helpers";

const baseURL = membersBaseURL();

const _post = (url, params) => window.axios.post(url, params, { baseURL });
const _put = (url, params) => window.axios.put(url, params, { baseURL });
const _delete = url => window.axios.delete(url, { baseURL });
const _get = url => window.axios.get(url, { baseURL });

export default {
  get(context, params) {
    const queryString = new URLSearchParams(params).toString();
    return new Promise((resolve, reject) => {
      return _get(`/next-releases?${queryString}`)
        .then(({ data: { results, next, previous, count } }) => {
          context.commit("setReleases", results);
          context.commit("setPagination", { next, previous, count });
          resolve({ data: { results, next, previous, count } });
        })
        .catch(reject);
    });
  },
  getById(context, id) {
    return new Promise((resolve, reject) => {
      return _get(`/next-releases/${id}`)
        .then(({ data }) => {
          context.commit("setRelease", data);
          resolve(data);
        })
        .catch(reject);
    });
  },
  post(context, params) {
    return new Promise((resolve, reject) => {
      return _post(`/next-releases`, params)
        .then(resolve)
        .catch(reject);
    });
  },
  put(context, params) {
    return new Promise((resolve, reject) => {
      return _put(`/next-releases/${params.id}`, params)
        .then(resolve)
        .catch(reject);
    });
  },
  delete(context, id) {
    return new Promise((resolve, reject) => {
      return _delete(`/next-releases/${id}`)
        .then(resolve)
        .catch(reject);
    });
  }
};
